import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { GameProvider } from './contexts/GameContext';
import { LanguageProvider } from './contexts/LanguageContext';
import GameLayout from './components/layout/GameLayout';
import HomePage from './pages/HomePage';
import './App.css';
import './seo-enhancements.css';

function App() {
  return (
    <GameProvider>
      <LanguageProvider>
        <div className="app">
          <Routes>
            <Route
              path="/zh"
              element={(
                <GameLayout>
                  <HomePage />
                </GameLayout>
              )}
            />
            <Route
              path="/en"
              element={(
                <GameLayout>
                  <HomePage />
                </GameLayout>
              )}
            />
            <Route
              path="/ja"
              element={(
                <GameLayout>
                  <HomePage />
                </GameLayout>
              )}
            />
            <Route path="/" element={<Navigate to="/zh" replace />} />
            <Route path="*" element={<Navigate to="/zh" replace />} />
          </Routes>
        </div>
      </LanguageProvider>
    </GameProvider>
  );
}

export default App;